import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class VuCardInlineFrame extends React.Component {
  render() {
    const {frameUrl, hasVideo, vucardStyle} = this.props;
    return (
      <iframe className={cx('vuCardFrame', `vuCardFrame--${vucardStyle}`, {'vuCardFrame--has-video': hasVideo})}
              src={frameUrl}
              id="vuCardFrame"
              title="vuCardFrame"
              name="vuCardFrame"
              scrolling="no"
              frameBorder="0"/>
    );
  }
}

VuCardInlineFrame.displayName = 'VuCardInlineFrame';

VuCardInlineFrame.propTypes = {
  frameUrl: PropTypes.string.isRequired,
  hasVideo: PropTypes.bool,
  vucardStyle: PropTypes.string.isRequired
};

